<table class="table" [ngSwitch]="attributeType">

  <ng-container *ngSwitchCase="'CLIENT'">
    <thead>
    <tr>
      <th>
        #
      </th>
      <th>
        Client Name
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let result of results">
      <td>{{result.id}}</td>
      <td>{{result.name}}</td>
    </tr>
    </tbody>
  </ng-container>
  <ng-container *ngSwitchCase="'ASD'">
    <thead>
    <tr>
      <th>
        #
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let result of results">
      <td>CLIENT</td>
    </tr>
    </tbody>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <tr>
      <td>universe..</td>
    </tr>
  </ng-container>
</table>
